// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as CrmUtils from "../CrmUtils.bs.js";
import * as Belt_List from "../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as TabPropFactory from "../../root/crm/to-be-migrated/routing/TabPropFactory.bs.js";
import * as ListUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getActiveTab(activeTabId, tabsList) {
  var activeTab = List.find_opt((function (tab) {
          return tab.url.hash === activeTabId;
        }), tabsList);
  if (activeTab !== undefined) {
    return activeTab;
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("WorkspaceComponent.re", "Active tab not in state", undefined), undefined);
  }
}

function reducer(state, action) {
  if (typeof action === "number") {
    return {
            tabsList: state.tabsList,
            activeTabId: state.activeTabId,
            refreshTab: !state.refreshTab
          };
  }
  switch (action.TAG | 0) {
    case /* AddTab */0 :
        var newTab = action._0;
        if (action._1) {
          var newTabWithProps = TabPropFactory.createCRMTab(undefined, newTab);
          return {
                  tabsList: List.append(state.tabsList, {
                        hd: newTabWithProps,
                        tl: /* [] */0
                      }),
                  activeTabId: newTabWithProps.url.hash,
                  refreshTab: state.refreshTab
                };
        }
        var activeTab = getActiveTab(state.activeTabId, state.tabsList);
        var newTabWithProps$1 = TabPropFactory.createCRMTab(undefined, newTab);
        var existingNewTab = List.find_opt((function (tab) {
                return CrmUtils.isURLSame(tab.url, newTabWithProps$1.url, true);
              }), state.tabsList);
        if (existingNewTab !== undefined) {
          if (CrmUtils.isURLSame(activeTab.url, newTabWithProps$1.url, true)) {
            return state;
          } else {
            return {
                    tabsList: state.tabsList,
                    activeTabId: existingNewTab.url.hash,
                    refreshTab: state.refreshTab
                  };
          }
        } else {
          return {
                  tabsList: List.append(state.tabsList, {
                        hd: newTabWithProps$1,
                        tl: /* [] */0
                      }),
                  activeTabId: newTabWithProps$1.url.hash,
                  refreshTab: state.refreshTab
                };
        }
    case /* RemoveTab */1 :
        var tabIndex = action._0;
        var tabsCount = List.length(state.tabsList);
        if (tabsCount <= 1) {
          return state;
        }
        var removedTab = List.find((function (tab) {
                return tab.url.hash === tabIndex;
              }), state.tabsList);
        var adjacentLeftTab = ListUtils$Catalyst.prev(removedTab, state.tabsList, (function (tab1, tab2) {
                return tab1.url.hash === tab2.url.hash;
              }));
        if (adjacentLeftTab !== undefined) {
          return {
                  tabsList: List.filter(function (tab) {
                          return tab.url.hash !== removedTab.url.hash;
                        })(state.tabsList),
                  activeTabId: adjacentLeftTab.url.hash,
                  refreshTab: state.refreshTab
                };
        } else {
          return state;
        }
    case /* ReplaceTab */2 :
        var newReplacedTab = TabPropFactory.createCRMTab(Caml_option.some(state.activeTabId), action._0);
        var newTabList = List.map((function (tab) {
                var match = tab.url.hash === state.activeTabId;
                if (match) {
                  return newReplacedTab;
                } else {
                  return tab;
                }
              }), state.tabsList);
        return {
                tabsList: newTabList,
                activeTabId: newReplacedTab.url.hash,
                refreshTab: state.refreshTab
              };
    case /* SetActiveTab */3 :
        var tabIndex$1 = action._0;
        if (tabIndex$1 === state.activeTabId) {
          return state;
        } else {
          return {
                  tabsList: state.tabsList,
                  activeTabId: tabIndex$1,
                  refreshTab: state.refreshTab
                };
        }
    case /* ToggleTabCancelCTA */4 :
        var uId = action._0;
        var finalList = Belt_List.map(state.tabsList, (function (e) {
                if (uId === e.uId) {
                  return {
                          component: e.component,
                          label: e.label,
                          url: e.url,
                          showCancelButton: !e.showCancelButton,
                          uId: e.uId
                        };
                } else {
                  return e;
                }
              }));
        return {
                tabsList: finalList,
                activeTabId: state.activeTabId,
                refreshTab: state.refreshTab
              };
    
  }
}

export {
  getActiveTab ,
  reducer ,
  
}
/* CrmUtils Not a pure module */
